import { Pipe, PipeTransform } from '@angular/core';
import { Duration } from './models/flight-duration.interfaces';

@Pipe({
  name: 'flightDuration'
})

/**
 * Takes a Duration object and return the formatted duration in day, hours and minutes.
 * @example
 * flightDuration: Duration = {day: 1, hour: 2, minute: 30} will be formatted to 1d 2h 30mn
 * flightDuration: Duration = {day: 0, hour: 16, minute: 45} will be formatted to 16h 45mn
 * @constructor
 * @param {Duration} flightDuration - flight duration object.
 */
export class FlightDurationPipe implements PipeTransform {
  transform(flightDuration: Duration): string {
    const { day, hour, minute } = flightDuration;
    return `${day > 0 ? `${day}d ` : ''}${hour > 0 ? `${hour}h ` : ''}${
      minute > 0 ? `${minute}m` : ''
    }`;
  }
}
